
import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const MissionSection = () => {
  // Add fade-in effect on initial load
  const [isLoaded, setIsLoaded] = useState(false);
  useEffect(() => {
    setIsLoaded(true);
  }, []);

  return (
    <section className="py-10 md:py-16 bg-mint-50">
      <div className="container-custom">
        <h2 className="text-2xl md:text-3xl font-bold mb-8 md:mb-12 text-center">Our Mission</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center">
          <div className="order-2 md:order-1">
            <h3 className="text-xl md:text-2xl font-semibold mb-4">Promoting Better Armpit Health</h3>
            <p className="text-sm md:text-base text-muted-foreground mb-4">
              At Armpits.com, we believe that proper underarm care is a crucial yet often overlooked aspect of personal hygiene and wellness. Our mission is to educate and provide the best products for your armpit health.
            </p>
            <p className="text-sm md:text-base text-muted-foreground mb-6">
              We test hundreds of products each year so you don't have to, bringing you only the best options backed by expert research and real customer experiences.
            </p>
            <Button asChild variant="outline" className="button-hover">
              <Link to="/about">Learn More About Us</Link>
            </Button>
          </div>
          <div 
            className="order-1 md:order-2 rounded-lg overflow-hidden shadow-xl image-hover"
            style={{
              opacity: isLoaded ? 1 : 0,
              transform: isLoaded ? 'translateY(0)' : 'translateY(20px)',
              transition: 'all 0.7s ease-out 0.5s',
            }}
          >
            <img
              src="/lovable-uploads/ceeb93c6-066d-4e4d-b558-17d157481684.png"
              alt="Natural armpit care in green environment"
              className="w-full h-auto object-cover"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default MissionSection;
